import client from "./client"

export const userService = {
    login,
    me,
    allAboutMe,
    logout,
    forgotPassword,
    resetPassword,
    confirmEmail,
    checkEmail,
    checkCard,
    createAccountForSelectedCard,
    createAccountForCompany,
    checkCardPin,
    sendInvitation,
    sendInvitationOldUser,
    changePassword,
    logoutOtherLocations,
    updateSessionData,
    saveConsents
};

function me(){
    return client.get('/api/me/');
}

function allAboutMe(){
    return client.get('/api/all-about-me/');
}

function login(username, password, document_type){
    return client.post('/api/login/', {
        'username': username,
        'password': password,
        'document_type': document_type
    });
}

function logout() {
    return client.get('/api/logout/');
}

function forgotPassword(username){
    return client.post('/api/forgot-password/', {
        'username': username,
    });
}

function resetPassword(password, confirm_code) {
    return client.post('/api/reset-password/', {
        'password': password,
        'confirm_code': confirm_code
    });
}

function confirmEmail(confirm_code){
    return client.post('/api/confirm-email/', {
        'confirm_code': confirm_code,
    });
}

function checkEmail(email){
    return client.post('/api/check/email/', {
        'email': email
    })
}

function checkCard(card){
    return client.post('/api/check/card/', {
        'card': card
    })
}

////////////NEW

function createAccountForSelectedCard(username, password, confirm_code){
    return client.post('/api/create-account/', {
        'username': username,
        'password': password,
        'confirm_code': confirm_code
    })
}

function createAccountForCompany(username, password, company_registration_number){
    return client.post('/api/create-account/', {
        'username': username,
        'password': password,
        'company_registration_number': company_registration_number
    })
}

function checkCardPin(card, pin, store_in_session){
    let data = {
        'card': card,
        'pin': pin
    };
    if (store_in_session){
        data['store'] = 'session';
    }
    return client.post('/api/check/card-pin', data);
}

function sendInvitation(card){
    let data = {
        'card': card
    }
    return client.post('/api/invite-registration/', data);
}

function sendInvitationOldUser(email, password){
    let data = {
        'email': email,
        'password': password,
    }
    return client.post('/api/invite-registration-old-user/', data);
}

function changePassword(current, newPassword){
    return client.post('/api/change-password/', {
        'current': current,
        'new_password': newPassword
    })
}

function logoutOtherLocations(){
    return client.get('/api/logout-other/');
}


function updateSessionData(document_type) {

    return client.post('/api/update-session-data/', {
        'document_type': document_type
    })
}

function saveConsents(consents){
    return client.post('/api/save-consents/', consents);
}



